interface Props {
    firstName?: string;
    lastName?: string;
    middleName?: string;
    suffix?: string;
}

export default function getFullName({ firstName, lastName, middleName, suffix }: Props) {
    return [
        firstName ?? "",
        middleName ? `${middleName.charAt(0).toUpperCase()}.` : "",
        lastName ?? "",
        suffix ?? "",
    ]
        .filter(Boolean)
        .join(" ");
}